import React from "react";
import styles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";

type Props = {
  title: string;
};
const FinecoPortfolioTitle: React.FC<Props> = ({ title }) => {
  return <h1 className={styles.portfolioTitle}>{title}</h1>;
};

export default FinecoPortfolioTitle;
